import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './addDoctor.module.scss';
import arrow_down from '../../static/images_pfizer/assistant/arrow_down.png'
import green_arrow_right from '../../static/images_pfizer/assistant/green_arrow_right.png'
import assistant_doctor_avatar from '../../static/images_pfizer/assistant/assistant_doctor_avatar.png'
import location from '../../static/images_pfizer/assistant/location.png';
import no_related_doctor from '../../static/images_pfizer/assistant/no_related_doctor.png';
import no_doctor_result from '../../static/images_pfizer/assistant/no_doctor_result.png';
import choose_project_icon from '../../static/images_pfizer/assistant/choose_project_icon.png';
import { Button } from 'antd-mobile-v5';
import { InputItem, Picker, List, Toast } from 'antd-mobile';
import { ApiCore } from '../../api';

const api = new ApiCore();

let timeout: any = null;

function Workbench(props: any) {

    const [list, setList] = useState([1, 2 , 3]);
    const [hasDoctor, setHasDoctor] = useState<any>(null);
    const [doctorInfo, setDoctorInfo] = useState<any>({});
    const [projectList, setProjectList] = useState<any>([]);
    const [showCover, setShowCover] = useState(false);
    const [showChooseProject, setShowChooseProject] = useState(false);
    const [project, setProject] = useState<any>([]);
    const [phone, setPhone] = useState('');


    useEffect(() => {
        document.title = '添加医生';
        initData();
        return () => {
            clearTimeout(timeout);
        }
    }, [])

    const initData = () => {
        api.getAssistantGroupSelect().then((res: any) => {
            if (res.data) {
                let _data = (res.data || []).map((val: any) => {
                    return {
                        label: val.name,
                        value: val.code
                    }
                })
                setProjectList(_data);
                _data[0] && setProject([_data[0].value]);
            }
        });
    };

    const toShowProject = () => {
        setShowChooseProject(true);
    }

    // 科室
    const onProjectList =  (value: any) => {
        setProject(value);
    }

    // 手机号
    const onPhone = (event: any) => {
        setPhone(event.target.value);
    }

    const onSearch = () => {
        if (phone.length > 11) {
            Toast.info('请输入正确的手机号码', 0.8);
            return;
        }
        api.getTeamDoctorsSearch({
            phone: phone
        }).then(res => {
            if (res.code == '0') {
                if (res.data) {
                    setHasDoctor(true);
                    setDoctorInfo(res.data);
                } else {
                    setHasDoctor(false);
                }
            }
        })
    }

    const submitInvite = () => {
        api.submitTeamBindDoctor({
            doctorCode: doctorInfo.code,
            groupCode: project[0]
        }).then((res: any) => {
            if (res.code == 0) {
                Toast.info('邀请成功');
            } else {
                Toast.info(res.message || '邀请失败');
            }
        });
    }

    const renderText = (status: string | number) => {
        if (status == 1) {
            return '未激活'
        } else if (status == 2) {
            return '未授权'
        } else if (status == 3) {
            return '待确认'
        } else if (status == 4) {
            return '已关联'
        }
        return null;
    }

    return (
        <div className={`${styles.addDoctor_content}`}>

            <div className={styles.head_middle}>
                <div className={styles.middle_left}>
                    <div className={styles.left_text}>搜索医生</div>
                </div>
            </div>

            <div className={styles.head_content}>
                <div className={styles.content_card}>
                    <div className={styles.card_title}>手机号搜索</div>
                    <div className={styles.card_middle_line}></div>
                    <div className={styles.card_input}>
                        <div>手机号</div>
                        <input type='number' autoFocus={true} onChange={onPhone} />
                    </div>
                    <div className={styles.card_middle_line}></div>
                    <div className={styles.card_bottom} onClick={onSearch}>
                        搜索医生
                    </div>
                </div>
            </div>

            <div className={styles.head_middle}>
                <div className={styles.middle_left}>
                    <div className={`${styles.left_text} ${styles.left_text_extra}`}>通过手机号可以搜索医生信息，申请后请耐心等待医生审核通过。</div>
                </div>
            </div>

            {
                hasDoctor !== null && 
                <div className={styles.head_middle}>
                    <div className={styles.middle_left}>
                        <div className={styles.left_text}>搜索结果</div>
                    </div>
                </div>
            }

            {
                hasDoctor === true && 
                <div className={styles.head_content}>
                    <div className={styles.content_card}>
                        <div className={styles.card_top}>
                            <div className={styles.top_left}>
                                <img src={assistant_doctor_avatar} alt="" />
                            </div>
                            <div className={styles.top_middle}>
                                <div className={styles.top_middle_head}>
                                    <span>{doctorInfo.name}</span>
                                    <span>{doctorInfo.title}</span>
                                </div>
                                <div className={styles.top_middle_middle}>
                                    <span>{doctorInfo.institution}</span>
                                    <span>{doctorInfo.dept}</span>
                                </div>
                            </div>
                        </div>

                        <div className={styles.card_middle_line}></div>
                        { doctorInfo.state != 4 ?
                            <div className={styles.card_bottom} onClick={() => { toShowProject() }}>
                                立即申请
                            </div>
                            :
                            <div className={styles.card_bottom}>
                                {renderText(doctorInfo.state)}
                            </div>
                        }

                    </div>
                </div>
            }
            {
                hasDoctor === false &&
                <div className={styles.head_content}>
                    <div className={styles.content_card}>
                        <div className={styles.no_result_title}>
                            未找到医生
                        </div>
                        <div className={styles.no_result_sub_title}>
                            该手机号下未搜索到医生信息，若您确定手机号输入正确，可以通过发送短信邀请医生进行注册
                        </div>
                        <div className={styles.no_result_img}>
                            <img src={no_doctor_result} alt="" />
                        </div>
                        <div className={styles.card_middle_line}></div>
                        <div className={styles.card_bottom}>
                            立即发送邀请短信
                        </div>
                    </div>
                </div>
            }

            {
                showChooseProject && 
                <>
                    <div className={styles.cover_mask}></div>
                    <div className={styles.choose_project_card}>
                        <img className={styles.choose_project_card_img} src={choose_project_icon} alt="" />
                        <div className={styles.choose_project_title}>选择项目和分配任务</div>
                        <div className={styles.card_middle_line}></div>
                        <div className={styles.choose_project_task}>
                            <div>邀请项目</div>
                            <Picker
                                    data={projectList}
                                    cols={1}
                                    className={`${styles.picker}`}
                                    value={project}
                                    extra={'请选择'}
                                    onChange={(v: any) => onProjectList(v)}
                                >
                                    <List.Item
                                        arrow={'horizontal'}
                                    ></List.Item>
                            </Picker>
                        </div>
                        {/* <div className={styles.card_middle_line}></div>
                        <div className={styles.choose_project_task_num}>
                            <div>待分配任务额</div>
                            <InputItem type='text' value='2000' disabled />
                        </div>
                        <div className={styles.card_middle_line}></div>
                        <div className={styles.choose_project_target_num}>
                            <div>目标数</div>
                            <InputItem type='text'  />
                        </div> */}
                        <div className={styles.card_middle_line}></div>
                        <div className={styles.choose_project_target_btn}>
                            <div>
                                <Button onClick={() => {
                                    setShowChooseProject(false);
                                }}>返回</Button>
                            </div>
                            <div>
                                <Button onClick={() => {
                                    submitInvite()
                                }}>确认邀请</Button>
                            </div>
                        </div>
                    </div>
                </>
            }

        </div>
    )

}

export default Workbench;